import { useState } from 'react'
import { useEntityCrud } from '../../hooks/useEntityCrud'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

const Create = () => {

    const navigate = useNavigate()

    const {addData} = useEntityCrud('ReIssue/setReIssueRules')

    const [title,setTitle] = useState('')
    const [issueTimes,setIssueTimes] = useState('')
    const [issuePrice,setIssuePrice] = useState('')
    const [preparationDays,setPreparationDays] = useState('')

    const setIssuePriceHandler = value => {
        value = value.toString().replace(/,/g,'')
        value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value)
        if(value == 'NaN' || !value)
            value = '';
        setIssuePrice(value)
    }

    const save = () => {
        const postedData = {
            title,
            issueTimes: parseInt(issueTimes),
            issuePrice: parseInt(issuePrice.toString().replace(/,/g,'')),
            issuePreparationTime: parseInt(preparationDays)
        }
        addData(postedData).then(({data}) => {
            if(data.status){
                toast.success('قانون جدید با موفقیت ایجاد شد')
                navigate(-1)
            }else
                data.errors.map(err => toast.error(err.message))
        })
    }

    return (
        <div className="card">
            <div className="card-header px-4">
                <div className="card-title">ایجاد قانون صدور مجدد</div>
            </div>
            <div className="card-body p-4">
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>عنوان</label>
                            <input type="text" className="form-control" value={title} onChange={e => setTitle(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>مرتبه صدور</label>
                            <input type="tel" className="form-control ltr-input" value={issueTimes} onChange={e => setIssueTimes(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>مبلغ</label>
                            <input type="tel" className="form-control ltr-input" value={issuePrice} onChange={e => setIssuePriceHandler(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>زمان صدور (روز)</label>
                            <input type="tel" className="form-control ltr-input" value={preparationDays} onChange={e => setPreparationDays(e.target.value)} />
                        </div>
                    </div>
                </div>
                <button className="btn btn-success" onClick={save}>ذخیره اطلاعات</button>
            </div>
        </div>
    )
}

export default Create